import axios from 'axios';
import moment from 'moment';
import constants from '../../config/constants';
import { getGlobalCurrentBatchUtils } from '../../utils/commonFunc';

export const GET_SRCH_SELECT = 'GET_SRCH_SELECT';
export const GET_ALL_STUDENTS = 'GET_ALL_STUDENTS';
export const GET_STUDENT = 'GET_STUDENT';

// Attendace
export const GET_CLASS_PERIODS = 'GET_CLASS_PERIODS';
export const GET_STUDENTS_ABSENTEES = 'GET_STUDENTS_ABSENTEES';

export const GET_COURSE_STUDENTS = 'GET_COURSE_STUDENTS';
export const GET_SCHOOL_COURSE_STUDENTS = 'GET_SCHOOL_COURSE_STUDENTS';

// Home work
export const GET_ALL_HOME_WORK = 'GET_ALL_HOME_WORK';
export const GET_STUDENTS_HOME_WORK_STATUS = 'GET_STUDENTS_HOME_WORK_STATUS';

// Assignment
export const GET_ALL_ASSIGNMENT = 'GET_ALL_ASSIGNMENT';
export const GET_STUDENTS_ASSIGNMENT_STATUS = 'GET_STUDENTS_ASSIGNMENT_STATUS';

// Notice board
export const GET_ALL_NOTICE_BOARDS = 'GET_ALL_NOTICE_BOARDS';

// Circular
export const GET_ALL_CIRCULAR = 'GET_ALL_CIRCULAR';

// Leave
export const GET_COURSE_STUDENTS_LEAVE = 'GET_COURSE_STUDENTS_LEAVE';
export const GET_STUDENT_LEAVES = 'GET_STUDENT_LEAVES';

// Day time slot
export const GET_DAY_TIME_SLOTS_FOR_COURSE = 'GET_DAY_TIME_SLOTS_FOR_COURSE';
export const GET_EMPLOYEE_TIME_SLOTS = 'GET_EMPLOYEE_TIME_SLOTS';

// Assignment
export const GET_ALL_MEETING = 'GET_ALL_MEETING';
export const GET_MEETING = 'GET_MEETING';

// Full info
export const CLEAR_STUDENT_FULL_INFO = 'CLEAR_STUDENT_FULL_INFO';
export const GET_STUDENT_FULL_INFO = 'GET_STUDENT_FULL_INFO';
//= ========== Reducer call functions begin ===========//

export const getAllStudents = studentsData => ({
  type: GET_ALL_STUDENTS,
  studentsData,
});

export const getCourseStudents = courseStudentData => ({
  type: GET_COURSE_STUDENTS,
  courseStudentData,
});

export const getSchoolCourseStudents = courseStudents => ({
  type: GET_SCHOOL_COURSE_STUDENTS,
  courseStudents,
});

export const getStudent = student => ({
  type: GET_STUDENT,
  student,
});

// Attendance
export const getClassPeriods = classPeriods => ({
  type: GET_CLASS_PERIODS,
  classPeriods,
});

export const getStudentsAbsentees = studentsAbsentees => ({
  type: GET_STUDENTS_ABSENTEES,
  studentsAbsentees,
});

// Home work
export const getAllHomeWork = homeWorks => ({
  type: GET_ALL_HOME_WORK,
  homeWorks,
});

export const getStudentsHomeWorkStatus = studentsStatus => ({
  type: GET_STUDENTS_HOME_WORK_STATUS,
  studentsStatus,
});

// Assignment
export const getAllAssignment = assignmentsData => ({
  type: GET_ALL_ASSIGNMENT,
  assignmentsData,
});

export const getStudentsAssignmentStatus = studentsStatus => ({
  type: GET_STUDENTS_ASSIGNMENT_STATUS,
  studentsStatus,
});

// Notice board
export const getAllNoticeBoards = noticeBoards => ({
  type: GET_ALL_NOTICE_BOARDS,
  noticeBoards,
});

export const getAllCirculars = circulars => ({
  type: GET_ALL_CIRCULAR,
  circulars,
});

// Leave
export const getCourseStudentsLeave = sLeaves => ({
  type: GET_COURSE_STUDENTS_LEAVE,
  sLeaves,
});

export const getStudentsLeave = leaves => ({
  type: GET_STUDENT_LEAVES,
  leaves,
});

// Fetch day time slot action
export const getDayTimeSlotsForCourse = dayTimeSlots => ({
  type: GET_DAY_TIME_SLOTS_FOR_COURSE,
  dayTimeSlots,
});

export const getEmployeeTimeSlot = empTimeSlots => ({
  type: GET_EMPLOYEE_TIME_SLOTS,
  empTimeSlots,
});

// Meeting
export const getAllMeeting = meetingsData => ({
  type: GET_ALL_MEETING,
  meetingsData,
});

export const getMeeting = meeting => ({
  type: GET_MEETING,
  meeting,
});

export const clearStudentFullInfo = () => ({
  type: CLEAR_STUDENT_FULL_INFO,
});

export const getStudentFullInfo = (dataType, resData, passParams) => {
  return {
    type: GET_STUDENT_FULL_INFO,
    dataType,
    resData,
    ...passParams,
  };
};
//= ========== Reducer call functions begin ===========//

export const fetchSchoolStudentsService = data => async dispatch => {
  const { searchParams: searchString, pageParams, batchId = 0, courseId = 0 } = data;
  try {
    const res = searchString
      ? await axios.post(
          `${constants.API_BASE_URL}/api/admin/get-school-student-by-filter/${data.schoolId}${constants.makeParams(
            pageParams
          )}`,
          { searchKeyWord: searchString, batchId, courseId },
          constants.setHeader(data.token)
        )
      : await axios.get(
          `${constants.API_BASE_URL}/api/admin/get-school-student-by-batch/${data.schoolId}/${
            data.batchId
          }${constants.makeParams(pageParams)}`,
          constants.setHeader(data.token)
        );
    dispatch(getAllStudents(res.data));
  } catch (err) {
    console.error('err', err);
  }
};

export const saveStudentService = data => () => {
  const { postData, token, batchId, courseId } = data;
  return axios.post(
    `${constants.API_BASE_URL}/api/admin/create-student/${batchId}/${courseId}`,
    postData,
    constants.setHeader(token)
  );
};

export const fetchStudentService = data => async dispatch => {
  const res = await axios.get(
    `${constants.API_BASE_URL}/api/student/${data.studentId}/${data?.batchId}`,
    constants.setHeader(data.token)
  );
  return dispatch(getStudent(res.data));
};

export const updateStudentService = data => () => {
  return axios.put(
    `${constants.API_BASE_URL}/api/student/update-student/${data.studentId}`,
    data.postData,
    constants.setHeader(data.token)
  );
};

export const deleteStudentService = data => () => {
  return axios.delete(
    `${constants.API_BASE_URL}/api/admin/delete-student/${data.studentId}`,
    constants.setHeader(data.token)
  );
};

export const fetchCourseStudentsService = data => async dispatch => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/employee/course-students-by-page/${data?.courseId}/${
        data.batchId
      }${constants.makeParams(data.pageParams)}`,
      constants.setHeader(data.token)
    );
    dispatch(getCourseStudents(res.data));
    return res.data;
  } catch (err) {
    console.error('err-fetchCourseStudentsService', err);
  }
};

export const fetchSchoolCourseStudentsService = data => async dispatch => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/employee/course-students/${data.courseId}/${data.batchId}`,
      constants.setHeader(data.token)
    );
    dispatch(getSchoolCourseStudents(res.data));
    return res.data;
  } catch (err) {
    console.error('err', err);
  }
};

//* ***************** Attendance ******************//
// "Period 1".."Period 10" is the literal timePeriod text the timetable grid saves (see
// TIMETABLE_PERIODS in TimetableAllocationGrid.jsx). Attendance's per-student record has fixed
// periodOne..periodTen fields to mark present/absent against, so we derive that key here -
// mirrors the mapping the backend used to do server-side in the now-unused class-periords API.
const PERIOD_ORDER = [
  'Period 1',
  'Period 2',
  'Period 3',
  'Period 4',
  'Period 5',
  'Period 6',
  'Period 7',
  'Period 8',
  'Period 9',
  'Period 10',
];
const PERIOD_KEY_BY_LABEL = {
  'Period 1': 'periodOne',
  'Period 2': 'periodTwo',
  'Period 3': 'periodThree',
  'Period 4': 'periodFour',
  'Period 5': 'periodFive',
  'Period 6': 'periodSix',
  'Period 7': 'periodSeven',
  'Period 8': 'periodEight',
  'Period 9': 'periodNine',
  'Period 10': 'periodTen',
};

export const fetchClassPeriodsService = data => async dispatch => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/employee/course-time-table/${data.courseId}/${data.batchId}/${data.schoolId}/${data.day}`,
      constants.setHeader(data.token)
    );
    const classPeriods = [...(res.data || [])]
      .sort((a, b) => PERIOD_ORDER.indexOf(a.timePeriod) - PERIOD_ORDER.indexOf(b.timePeriod))
      .map(item => ({ ...item, period: PERIOD_KEY_BY_LABEL[item.timePeriod] }));
    dispatch(getClassPeriods(classPeriods));
    return classPeriods;
  } catch (err) {
    console.error('err', err);
  }
};

export const fetchStudentAbsenteesService = data => async dispatch => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/employee/student-absentees/${data.courseId}/${data.batchId}/${data.date}`,
      constants.setHeader(data.token)
    );
    dispatch(getStudentsAbsentees(res.data));
    return res.data;
  } catch (err) {
    console.error('err', err);
  }
};

export const initiateAttendanceService = data => () => {
  if (data?.type === 'day') {
    return axios.post(
      `${constants.API_BASE_URL}/api/employee/initiate-student-attendance/${data.batchId}/${data.courseId}`,
      null,
      constants.setHeader(data.token)
    );
  } else if (data?.type === 'month') {
    return new Promise(resolve => setTimeout(() => resolve('Ok'), 2000));
  }
};

export const updateAttendanceService = data => () => {
  return axios.put(
    `${constants.API_BASE_URL}/api/employee/student-absentees/${data.schoolId}/${data.batchId}/${data.courseId}/${data.month}/${data.day}`,
    data.updateData,
    constants.setHeader(data.token)
  );
};

export const deleteStudentAbsentService = data => () => {
  return axios.delete(`${constants.API_BASE_URL}/api/employee/student-absentees/${data.month}/${data.day}`, {
    data: data.deleteData,
    headers: constants.setHeader(data.token).headers,
  });
};

//* ********************* Home work *************************//
export const fetchAllHomeWorksService = data => async dispatch => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/employee/student-task/${data.courseId}/${data.employeeId}/${moment(
        data.date
      ).format('YYYY-MM-DD')}`,
      constants.setHeader(data.token)
    );
    dispatch(getAllHomeWork(res.data));
  } catch (err) {
    console.error('err', err);
  }
};

export const saveHomeWorkService = data => () => {
  return axios.post(
    `${constants.API_BASE_URL}/api/employee/student-task`,
    data.homeWorkData,
    constants.setHeader(data.token)
  );
};

export const viewStudentHomeWorkStatusService = data => async dispatch => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/employee/student-task-status/${data.taskId}`,
      constants.setHeader(data.token)
    );
    return dispatch(getStudentsHomeWorkStatus(res.data));
  } catch (err) {
    console.error('err', err);
  }
};

export const updateHomeWorkService = data => () => {
  return axios.put(
    `${constants.API_BASE_URL}/api/employee/student-absentees/${data.month}/${data.day}`,
    data.updateData,
    constants.setHeader(data.token)
  );
};

export const deleteHomeWorkService = data => () => {
  return axios.delete(`${constants.API_BASE_URL}/api/employee/student-task/${data.taskId}`, {
    data: data.deleteData,
    headers: constants.setHeader(data.token).headers,
  });
};

//* ******************  Assignment ***********************//
export const fetchAllAssignmentsService = data => async dispatch => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/employee/student-assignment/${data.courseId}/${data.employeeId}/${moment(
        data.date
      ).format('YYYY-MM')}${constants.makeParams(data.pageParams)}`,
      constants.setHeader(data.token)
    );
    return dispatch(getAllAssignment(res.data));
  } catch (err) {
    console.error('err', err);
  }
};

export const saveAssignmentService = data => () => {
  return axios.post(
    `${constants.API_BASE_URL}/api/employee/student-assignment`,
    data.assignmentData,
    constants.setHeader(data.token)
  );
};

export const viewStudentAssignmentStatusService = data => async dispatch => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/employee/student-assignment-status/${data.assignmentId}`,
      constants.setHeader(data.token)
    );
    return dispatch(getStudentsAssignmentStatus(res.data));
  } catch (err) {
    console.error('err', err);
  }
};

export const updateAssignmentService = data => () => {
  return axios.put(
    `${constants.API_BASE_URL}/api/employee/student-absentees/${data.month}/${data.day}`,
    data.updateData,
    constants.setHeader(data.token)
  );
};

export const deleteAssignmentService = data => () => {
  return axios.delete(`${constants.API_BASE_URL}/api/employee/student-assignment/${data.assignmentId}`, {
    data: data.deleteData,
    headers: constants.setHeader(data.token).headers,
  });
};

//* ****************Notice board **************** */
export const fetchAllNoticeBoardService = data => async dispatch => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/common/notice-board/${data.schoolId}/${data.date}`,
      constants.setHeader(data.token)
    );
    dispatch(getAllNoticeBoards(res.data));
    return res;
  } catch (err) {
    console.error('err-create-notice-board-error', err.response);
  }
};

export const saveNoticeBoardService = data => () => {
  return axios.post(
    `${constants.API_BASE_URL}/api/admin/create-notice-board`,
    data.postData,
    constants.setHeader(data.token)
  );
};

export const deleteNoticeBoardService = data => () => {
  return axios.delete(
    `${constants.API_BASE_URL}/api/admin/delete-notice-board/${data.noticeBoardId}`,
    constants.setHeader(data.token)
  );
};

//* ****************Circular**************** */
export const fetchAllCircularService = data => async dispatch => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/common/circular/${data.schoolId}/${data.date}`,
      constants.setHeader(data.token)
    );
    return dispatch(getAllCirculars(res.data));
  } catch (err) {
    console.error('err', err);
  }
};

export const saveCircularService = data => () => {
  return axios.post(
    `${constants.API_BASE_URL}/api/admin/create-circular`,
    data.postData,
    constants.setHeader(data.token)
  );
};

export const deleteCircularService = data => () => {
  return axios.delete(
    `${constants.API_BASE_URL}/api/admin/delete-circular/${data.circularId}`,
    constants.setHeader(data.token)
  );
};

// Leaves
export const fetchCourseStudentsLeaveService = data => async dispatch => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/employee/students-leaves/${data.courseId}${constants.makeParams(data.pageParams)}`,
      constants.setHeader(data.token)
    );
    return dispatch(getCourseStudentsLeave(res.data));
  } catch (err) {
    console.error('err', err);
  }
};

export const fetchStudentLeavesService = data => async dispatch => {
  const res = await axios.get(
    `${constants.API_BASE_URL}/api/student/leave/${data.studentId}`,
    constants.setHeader(data.token)
  );
  return dispatch(getStudentsLeave(res.data));
};

// Course time table
export const GET_COURSE_TIME_TABLE = 'GET_COURSE_TIME_TABLE';
export const getCourseTimeTable = courseTimeTableList => ({
  type: GET_COURSE_TIME_TABLE,
  courseTimeTableList,
});

export const fetchCourseTimeTableApi = async (data, dispatch) => {
  const url = `${constants.API_BASE_URL}/api/student/timetable/${data.courseId}`;
  try {
    const res = await axios.get(url, constants.setHeader(data.token));
    if (dispatch) {
      dispatch(getCourseTimeTable(res.data));
    }
    return res;
  } catch (err) {
    console.error('fetchCourseTimeTableApi-err');
  }
};

export const fetchCourseTimeTableService = data => async dispatch => {
  const res = await fetchCourseTimeTableApi(data);
  dispatch(getCourseTimeTable(res.data));
  return res.data;
};

// Current day period time slot fetch
export const fetchCourseDayTimeSlotService = data => async dispatch => {
  const day =
    moment().format('ddd').toUpperCase() === 'SUN'
      ? moment().add(1, 'day').format('ddd').toUpperCase()
      : moment().format('ddd').toUpperCase();
  const url = `${constants.API_BASE_URL}/api/employee/course-time-table/${data.courseId}/${data.batchId}/${data.schoolId}/${day}`;
  // `${constants.API_BASE_URL}/api/student/timetable/${data.courseId}`,
  const res = await axios.get(url, constants.setHeader(data.token));
  dispatch(getDayTimeSlotsForCourse(res.data));
  return res.data;
};

export const fetchEmployeeTimeSlotService = data => async dispatch => {
  const res = await axios.get(
    `${constants.API_BASE_URL}/api/employee/time-table/${data.employeeId}`,
    constants.setHeader(data.token)
  );
  return dispatch(getEmployeeTimeSlot(res.data));
};

//* ******************  Meetings ***********************//
export const fetchAllMeetingsService = data => async dispatch => {
  const { token, courseId, batchId, pageParams } = data;
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/meetup/${courseId}/${batchId}${constants.makeParams(pageParams)}`,
      constants.setHeader(token)
    );
    dispatch(getAllMeeting(res.data));
    return res.data;
  } catch (err) {
    console.error('err', err);
  }
};

export const saveMeetingService = data => () => {
  const { token, postData } = data;
  return axios.post(`${constants.API_BASE_URL}/api/meetup`, postData, constants.setHeader(token));
};

export const fetchMeetingService = data => async dispatch => {
  const { token, meetingId } = data;
  try {
    const res = await axios.get(`${constants.API_BASE_URL}/api/meetup/${meetingId}`, constants.setHeader(token));
    dispatch(getMeeting(res.data));
    return res.data;
  } catch (err) {
    console.error('err', err);
  }
};

export const updateMeetingService = data => () => {
  const { token, meetingId, postData } = data;
  return axios.put(`${constants.API_BASE_URL}/api/meetup/${meetingId}`, postData, constants.setHeader(token));
};

export const deleteMeetingService = data => () => {
  const { token, meetingId, deleteData } = data;
  return axios.delete(`${constants.API_BASE_URL}/api/meetup/${meetingId}`, {
    data: deleteData,
    headers: constants.setHeader(token).headers,
  });
};

// Full Info
export const fetchStudentFullInfoService = data => async dispatch => {
  const {
    type,
    studentId,
    schoolId,
    courseId,
    token,
    searchParams = null,
    pageParams = null,
    limit = 20,
    filterData,
    batchId,
  } = data;
  // console.error(data);
  const apis = {
    profile: `/api/student/${studentId}/${batchId}`,
    // activities: `/api/student/activities/${studentId}`,
    appreciations: `/api/student/appreciations/${studentId}`,
    homework: `/api/student/task-recent/${studentId}/${limit}`,
    assignments: `/api/student/assignment-recent/${studentId}/${limit}`,
    // feeStructure: `/api/admin/fee-structure-by-course-id/${schoolId}/${courseId}`,
    payments: `/api/admin/student-payment-history/${schoolId}/${batchId}/${studentId}/${courseId}`,
    feeStructure: `/api/admin/fee-structure-by-student-id/${schoolId}/${batchId}/${courseId}/${studentId}`,
  };
  const getQParams = () => {
    return `${pageParams ? constants.makeParams(pageParams[type]) : ''}${
      searchParams && pageParams
        ? constants.makeParams(searchParams[type], true)
        : searchParams && !pageParams
        ? constants.makeParams(searchParams[type])
        : ''
    }`;
  };
  if (type === 'activities') {
    const res = await axios.post(
      `${constants.API_BASE_URL}/api/admin/audit-log-by-filter/${schoolId}/${filterData?.page}/${filterData?.limit}`,
      filterData,
      constants.setHeader(token)
    );
    dispatch(getStudentFullInfo(type, res?.data, { studentId, courseId }));
  }
  if (apis?.[type]) {
    try {
      const res = await axios.get(`${constants.API_BASE_URL}${apis[type]}${getQParams()}`, constants.setHeader(token));
      dispatch(getStudentFullInfo(type, res?.data, { studentId, courseId }));
    } catch (err) {
      console.error(`err - fetchStudentFullInfoService - ${type}`, err);
    }
  }
};

export const payStudentFeePaymentService = data => () => {
  const { batchId = getGlobalCurrentBatchUtils().batchId } = data;
  const { schoolId, studentId } = data;
  const { token, ...rest } = data;
  return axios.post(
    `${constants.API_BASE_URL}/api/admin/student-payment/${schoolId}/${batchId}/${studentId}`,
    rest,
    constants.setHeader(token)
  );
};

export const scanAndUpdateAttendanceApi = data => {
  const { token, schoolId, qrText } = data;
  return axios.patch(
    `${constants.API_BASE_URL}/api/employee/mark-student-attendance-present/${schoolId}/${qrText}`,
    {},
    constants.setHeader(token)
  );
};

export const fetchOnlinePaymentLinkApi = async data => {
  const { token, schoolId, batchId, studentId } = data;
  return axios.get(
    `${constants.API_BASE_URL}/api/employee/mark-student-attendance-present/${schoolId}/${batchId}/${studentId}`,
    constants.setHeader(token)
  );
};
